import React, { useEffect, useState } from "react";
import { Tooltip, Polygon, Polyline } from "react-leaflet";
import { GEO_APIs } from "apihandlers/geography";

import "react-leaflet-markercluster/dist/styles.min.css";
import "leaflet/dist/leaflet.css";

import "../styles/index.css";
import "../styles/fleetmap.css";

const RoutesAndTerritories = (props: any) => {
  const {
    plottings,
    setPlottings,
    setShowCustomerCluster,
    setPlotDetail,
    showRoute,
    getCustomers,
    setShowTripDelivery,
    setShowUser,
    setPolyEdits,
    showOuterBoundry,
    showInnerBoundry,
    showTerritory,
    showDealers,
    showLabels,
    childRef,
  } = props;

  const [territory, setTerritory] = useState<any>(null);
  const [dealerBoundary, setDealerBoundary] = useState<any>(null);
  const [route, setRoute] = useState<any>(null);
  const [selectedPolygon, setSelectedPolygon] = useState(null);
  const [innerBoundry, setInnerBoundry] = useState<any>(null);
  // const [selectedRouteIds, setSelectedRouteIds] = useState<any>([]);
  useEffect(() => {
    if (showTerritory) {
      getTerritories();
    }
  }, [showTerritory]);

  if (childRef) {
    childRef.getTerritories = async () => {
      const args = {};
      const res: any = await GEO_APIs.getTerritory(args);
      const { status, response } = res;
      if (status === 200) {
        let territoryData = response.records;
        let tBound = territoryData.map((t, i) => {
          const territoryVertices = JSON.parse(t.vertices);
          return { name: t.name, vertices: territoryVertices, color: t.color };
        });
        setTerritory(tBound);
      }
    };
  }

  const getTerritories = async () => {
    const args = {};
    const res: any = await GEO_APIs.getTerritory(args);
    const { status, response } = res;
    if (status === 200) {
      let territoryData = response.records;
      console.log("territoryData: ", territoryData);
      let tBound = territoryData.map((t) => {
        const territoryVertices = JSON.parse(t.outerVertices);
        return { name: t.name, vertices: territoryVertices, color: t.color };
      });
      let outBoundry = tBound.filter((item) => item !== null);
      setTerritory(outBoundry);

      let innerBoundry = territoryData.map((i) => {
        const innerVertices = JSON.parse(i.innerVertices);
        return { name: i.name, vertices: innerVertices, color: i.color };
      });

      let iBoundry = innerBoundry.filter((item) => item !== null);
      setInnerBoundry(iBoundry);
      console.log("iBoundry", iBoundry);
    }
    getDealersBoundry();
  };

  const getDealersBoundry = async () => {
    const args = {};
    const res: any = await GEO_APIs.getDealersBoundry(args);
    const { status, response } = res;
    if (status === 200) {
      let dealersData = response.records;
      let dealerBound = dealersData.map((d, i) => {
        const dealerVertices = JSON.parse(d.vertices);
        return { name: d.name, vertices: dealerVertices, color: d.color };
      });

      setDealerBoundary(dealerBound);
    }
    getRoutes();
  };

  const getRoutes = async () => {
    const args = {};
    const res: any = await GEO_APIs.getCustomerRoutes(args);
    const { status, response } = res;
    if (status === 200) {
      let route = response.records;
      route = route.map((r, i) => {
        const routeVertices = JSON.parse(r.coordinates);
        return {
          name: r.routeName,
          vertices: routeVertices,
          color: r.color,
          id: r.id,
          routeName: "route",
        };
      });
      setRoute(route);
    }
  };

  const getPlotDetails = (info, index) => {
    // setSelectedRouteIds([info.id]);
    setShowCustomerCluster(false);
    console.log("info", info);
    if (info.routeName === "route") {
      getCustomers(null, info.id, "getRouteShops");
    }
    setPlotDetail(info);
    setPlottings(true);
    setShowTripDelivery(false);
    setShowUser(false);
    setPolyEdits(false);
    setSelectedPolygon(selectedPolygon === index ? null : index);
  };

  return (
    <>
      {/* dealers boundary plotting */}
      {showLabels &&
        showDealers &&
        dealerBoundary &&
        dealerBoundary.map((dealer, i) => {
          return (
            dealer.vertices && (
              <Polygon
                key={"dealer-" + i}
                positions={dealer.vertices}
                color={dealer.color}
                fillColor={dealer.color}
                className="zone"
                onclick={() => {
                  getPlotDetails(dealer, i);
                }}
                fillOpacity={selectedPolygon === i ? 0.7 : 0.1}
                opacity={0.5}
              >
                {showLabels ? (
                  <Tooltip
                    direction="right"
                    className={"zoneLabel"}
                    title={"dealer"}
                    offset={[10, 10]}
                    color={"blue"}
                    permanent
                  >
                    <span style={{ color: "blue" }}>{dealer.name}</span>
                  </Tooltip>
                ) : (
                  <Tooltip
                    direction="right"
                    className={"zoneLabel"}
                    title={"dealer"}
                    offset={[10, 10]}
                    color={"blue"}
                  >
                    <span style={{ color: "blue" }}>{dealer.name}</span>
                  </Tooltip>
                )}
              </Polygon>
            )
          );
        })}

      {/*territory plotting */}
      {showTerritory &&
        territory &&
        territory.map((boundary, i) => {
          return (
            boundary.vertices &&
            boundary.vertices.length > 0 && (
              <Polygon
                key={"territory-" + i}
                positions={boundary.vertices}
                color={boundary.color}
                fillColor={boundary.color}
                className="zone"
                onclick={() => {
                  getPlotDetails(boundary, i);
                }}
                fillOpacity={selectedPolygon === i ? 0.7 : 0.1}
                opacity={0.5}
              >
                {showInnerBoundry ? (
                  ""
                ) : (
                  <>
                    {showLabels ? (
                      <Tooltip
                        direction="right"
                        className={"zoneLabel"}
                        title={"label"}
                        offset={[10, 10]}
                        color={"blue"}
                        permanent={true}
                      >
                        <span style={{ color: "blue" }}>{boundary.name}</span>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        direction="right"
                        className={"zoneLabel"}
                        title={"label"}
                        offset={[10, 10]}
                        color={"blue"}
                      >
                        <span style={{ color: "blue" }}>{boundary.name}</span>
                      </Tooltip>
                    )}
                  </>
                )}
              </Polygon>
            )
          );
        })}

      {/* route plotting*/}
      {showRoute &&
        route &&
        route.map((route, i) => {
          return (
            route.vertices && (
              <Polyline
                key={"line-" + i}
                positions={route.vertices}
                color={route.color}
                onclick={() => getPlotDetails(route, i)}
              ></Polyline>
            )
          );
        })}

      {/* inner Boundry */}
      {showInnerBoundry &&
        innerBoundry &&
        innerBoundry.map((iBoundry, i) => {
          return (
            iBoundry.vertices &&
            iBoundry.vertices.length > 0 && (
              <Polygon
                key={"innerterritory-" + i}
                positions={iBoundry.vertices}
                color={iBoundry.color}
                fillColor={iBoundry.color}
                className="zone"
                onclick={() => {
                  getPlotDetails(iBoundry, i);
                }}
                fillOpacity={selectedPolygon === i ? 0.7 : 0.1}
                opacity={0.5}
              >
                {showLabels ? (
                  <Tooltip
                    direction="right"
                    className={"zoneLabel"}
                    title={"label"}
                    offset={[10, 10]}
                    color={"blue"}
                    permanent
                  >
                    <span style={{ color: "blue" }}>{iBoundry.name}</span>
                  </Tooltip>
                ) : (
                  <Tooltip
                    direction="right"
                    className={"zoneLabel"}
                    title={"label"}
                    offset={[10, 10]}
                    color={"blue"}
                    // permanent={false}
                  >
                    <span style={{ color: "blue" }}>{iBoundry.name}</span>
                  </Tooltip>
                )}
              </Polygon>
            )
          );
        })}
    </>
  );
};

export default RoutesAndTerritories;
